export default {
  header: {
    title: 'Køb gavekort',
  },
  checkout_btn: {
    title: 'Betaling',
    max_quantity: 'Højst {{max}} gavekort pr. køb',
  },
  items: {
    gift_card: {
      online: 'Gavekort kun til online-brug',
      online_and_store: 'Gavekort (kan indløses online og i butikken)',
      title: 'Vælg dit ønskede beløb',
      description: 'Læg gavekortet i kurven med det ønskede antal',
    },
    expiration: {
      label: 'Gyldigt i 3 år',
      title: 'God fornøjelse med at give gaver!',
      description: 'Modtageren kan indløse gavekortet frit inden for 3 år.',
    },
    delivery: {
      label: 'Leveres med det samme som PDF på e-mail',
      title: 'Øjeblikkelig levering som PDF på e-mail',
      description: 'Efter sikker betaling modtager du gavekortet med det samme.',
    },
  },
  form: {
    value: {
      title: 'Vælg gavekortets beløb',
      custom: {
        label: 'Eget beløb',
        placeholder: 'Indtast et beløb mellem {{min}} og {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Antal',
    },
    email: {
      title: 'Hvad er din e-mailadresse, så vi kan sende dig gavekortet?',
      placeholder: 'Din e-mailadresse',
      error: 'Ugyldig e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Køb gavekort?',
      subtitle_one: 'Vil du købe 1 gavekort til {{value}}?',
      subtitle_other: 'Vil du købe {{count}} gavekort til {{value}}?',
    },
    description: {
      total: 'I alt:',
      email: 'E-mail:',
      quantity: 'Antal',
      amount: 'Beløb',
    },
    footer: {
      cancel: 'Annuller',
      confirm: 'Bekræft',
    },
  },
};
